import React, { useContext } from 'react';
import LanguageContext from '../contexts/LanguageContext';
import { translations } from '../translations';
import ReactFlagsSelect from 'react-flags-select';

const Header = () => {
  const { language, setLanguage } = useContext(LanguageContext);
  const t = translations[language];

  const handleLanguageChange = (code) => {
    if (code === 'GB') {
      setLanguage('en');
    } else if (code === 'PL') {
      setLanguage('pl');
    }
  };

  return (
    <header className="bg-white/95 backdrop-blur shadow-md sticky top-0 z-50 border-b border-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16 md:h-20 gap-4">
          <div className="flex items-center gap-3 min-w-0">
            <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-indigo-600 to-violet-700 flex items-center justify-center text-white text-xl font-bold shadow-md shrink-0">
              DS
            </div>
            <div className="min-w-0">
              <div className="text-lg md:text-2xl font-bold text-slate-900 leading-tight truncate">
                {t.header.brand}
              </div>
              <div className="hidden sm:block text-[10px] md:text-xs uppercase tracking-wider text-indigo-600 font-semibold truncate">
                {t.header.tagline}
              </div>
            </div>
          </div>
          <div className="flex items-center gap-3 md:gap-4">
            <a
              href="/s"
              className="hidden sm:inline-flex bg-amber-400 hover:bg-amber-300 text-slate-900 font-bold py-2 px-5 rounded-full text-sm transition-all duration-300 shadow-sm hover:shadow-md"
            >
              {t.header.cta}
            </a>
            <ReactFlagsSelect
              selected={language === 'en' ? 'GB' : 'PL'}
              onSelect={handleLanguageChange}
              countries={['GB', 'PL']}
              customLabels={{ GB: 'English', PL: 'Polski' }}
              showOptionLabel={true}
              showSelectedLabel={true}
              placeholder="Select Language"
              className="flag-select"
            />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
